import { render, staticRenderFns } from "./SelectCharacteristics.vue?vue&type=template&id=9d360c08&scoped=true&"
import script from "./SelectCharacteristics.vue?vue&type=script&lang=js&"
export * from "./SelectCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./SelectCharacteristics.vue?vue&type=style&index=0&id=9d360c08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d360c08",
  null
  
)

export default component.exports